module.exports = __webpack_public_path__ + "assets/img/home_tech_6.55195f41.png";